import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  DateTime: { input: string; output: string; }
  Decim: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  JSON: { input: any; output: any; }
  NonEmptyString: { input: any; output: any; }
  PositiveInt: { input: any; output: any; }
  PostalCode: { input: any; output: any; }
};

export type AuthenticateCustomerInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type AuthenticateEmployeeInput = {
  employeeId: Scalars['ID']['input'];
  password: Scalars['String']['input'];
};

export type BrandStandard = {
  brandStandardId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  resolution?: Maybe<Scalars['String']['output']>;
};

export type BrandStandardEdge = {
  cursor: Scalars['String']['output'];
  node: BrandStandard;
};

export type BrandStandardInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
};

export type BrandStandardsConnection = {
  edges: Array<BrandStandardEdge>;
  nodes: Array<BrandStandard>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CacheControlScope =
  | 'PRIVATE'
  | 'PUBLIC';

export type Car = {
  color: Scalars['String']['output'];
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type CarInput = {
  color: Scalars['String']['input'];
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type CardAddBalance = {
  balanceToAdd?: Maybe<Scalars['Int']['output']>;
  currentBalance?: Maybe<Scalars['Int']['output']>;
  giftCardNumber?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type CardAddBalanceInput = {
  app_user_id: Scalars['Int']['input'];
  balanceToAdd: Scalars['Int']['input'];
  currentBalance: Scalars['Float']['input'];
  giftCardNumber: Scalars['BigInt']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  profile_id: Scalars['Int']['input'];
  session_id: Scalars['String']['input'];
  stripe_trans_id: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type CardAddBalanceResult = {
  card?: Maybe<GiftCard>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type Cart = {
  id: Scalars['ID']['output'];
  items: Array<OrderItem>;
};

export type ClaimedReward = {
  creationDate: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  profile: Profile;
  profileId: Scalars['Int']['output'];
  reward: Reward;
  rewardId: Scalars['Int']['output'];
};

export type Config = {
  setting: Scalars['String']['output'];
  storeId: Scalars['Int']['output'];
  termId: Scalars['Int']['output'];
  type: ConfigType;
  value: Scalars['String']['output'];
};

export type ConfigInput = {
  setting: Scalars['String']['input'];
  storeId: Scalars['Int']['input'];
  termId: Scalars['Int']['input'];
  value: Scalars['String']['input'];
};

export type ConfigTable = {
  setting: Scalars['String']['output'];
  storeId: Scalars['Int']['output'];
  termId: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type ConfigType = {
  id: Scalars['Int']['output'];
  metadata: Array<ConfigTypeMetadata>;
  setting: Scalars['String']['output'];
  type: ConfigTypeEnum;
};

export type ConfigTypeEnum =
  | 'BOOLEAN'
  | 'DROPDOWN'
  | 'FLOAT'
  | 'INTEGER'
  | 'RADIO'
  | 'STRING';

export type ConfigTypeMetadata = {
  id: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Connection = {
  connectionId: Scalars['String']['output'];
  disconnected: Scalars['Boolean']['output'];
  key: Scalars['ID']['output'];
  storeId: Scalars['Int']['output'];
  termId: Scalars['Int']['output'];
  time?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CoordinatesInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CreateCardsInSeriesInput = {
  cardSeries: Scalars['Int']['input'];
  initialCash?: InputMaybe<Scalars['Float']['input']>;
  numberOfCards?: InputMaybe<Scalars['Int']['input']>;
  production?: InputMaybe<Scalars['Boolean']['input']>;
  sequential?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCardsInSeriesUpdate = {
  batchIndex: Scalars['Int']['output'];
  cardNumbers: Array<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  executionArn: Scalars['ID']['output'];
  ok: Scalars['Boolean']['output'];
  totalBatches: Scalars['Int']['output'];
};

export type CreatePdvChangeSetInput = {
  name: Scalars['String']['input'];
  ownerEmployeeId: Scalars['ID']['input'];
  parentId: Scalars['ID']['input'];
};

export type CreditCardPaymentInput = {
  amount: Scalars['Int']['input'];
  token: Scalars['String']['input'];
};

export type Customer = {
  id: Scalars['Int']['output'];
  profile: Profile;
};

export type CustomerOrderInput = {
  appUserId?: InputMaybe<Scalars['Int']['input']>;
  car?: InputMaybe<CarInput>;
  claimedRewardId?: InputMaybe<Scalars['Int']['input']>;
  guestEmail?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  items: Array<OrderItemInput>;
  otterId?: InputMaybe<Scalars['String']['input']>;
  payment: PaymentInput;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pickupLocation: PercPickupLocation;
  pickupName?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['Int']['input']>;
  subtotal: Scalars['Int']['input'];
  taxAmount: Scalars['Int']['input'];
  time?: InputMaybe<Scalars['String']['input']>;
  total: Scalars['Int']['input'];
};

export type DefaultNotice = {
  brandStandard: BrandStandard;
  brandStandardViolated: Scalars['Int']['output'];
  defaultDate: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  notificationMethod: Scalars['String']['output'];
  reportedBy: Scalars['String']['output'];
  resolutionDate?: Maybe<Scalars['DateTime']['output']>;
  resolved: Scalars['Boolean']['output'];
  store: Store;
  storeId: Scalars['Int']['output'];
};

export type DefaultNoticeEdge = {
  cursor: Scalars['String']['output'];
  node: DefaultNotice;
};

export type DefaultNoticeInput = {
  brandStandardViolated: Scalars['Int']['input'];
  defaultDate: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  notificationMethod: Scalars['String']['input'];
  reportedBy: Scalars['String']['input'];
  resolutionDate?: InputMaybe<Scalars['DateTime']['input']>;
  resolved: Scalars['Boolean']['input'];
  storeId: Scalars['Int']['input'];
};

export type DefaultNoticesConnection = {
  edges: Array<DefaultNoticeEdge>;
  nodes: Array<DefaultNotice>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DiscountItemInput = {
  cartItemId: Scalars['ID']['input'];
  discounted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  itemId: Scalars['Int']['input'];
  modifiers: Array<OrderModifierInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  oldPrice?: InputMaybe<Scalars['Int']['input']>;
  oldTaxAmount?: InputMaybe<Scalars['Int']['input']>;
  otterId?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Int']['input'];
  taxAmount: Scalars['Int']['input'];
  taxRate: Scalars['Float']['input'];
  typewriterNote?: InputMaybe<Scalars['String']['input']>;
};

export type DiscountOrderInput = {
  appUserId?: InputMaybe<Scalars['Int']['input']>;
  claimedRewardId: Scalars['Int']['input'];
  items: Array<DiscountItemInput>;
  profileId: Scalars['Int']['input'];
  subtotal: Scalars['Int']['input'];
  taxAmount: Scalars['Int']['input'];
  total: Scalars['Int']['input'];
};

export type DiscountOrderModifier = {
  id: Scalars['ID']['output'];
  modifierId: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  quantity: Scalars['Float']['output'];
};

export type DiscountedOrder = {
  appUserId?: Maybe<Scalars['Int']['output']>;
  claimedRewardId: Scalars['Int']['output'];
  items: Array<DiscountedOrderItem>;
  profileId: Scalars['Int']['output'];
  subtotal: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type DiscountedOrderItem = {
  cartItemId: Scalars['ID']['output'];
  discounted: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  itemId: Scalars['Int']['output'];
  modifiers: Array<DiscountOrderModifier>;
  name?: Maybe<Scalars['String']['output']>;
  oldPrice?: Maybe<Scalars['Int']['output']>;
  oldTaxAmount?: Maybe<Scalars['Int']['output']>;
  otterId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  taxRate: Scalars['Float']['output'];
  typewriterNote?: Maybe<Scalars['String']['output']>;
};

export type EditBrandStandardInput = {
  brandStandardId: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
};

export type EditDefaultNoticeInput = {
  brandStandardViolated?: InputMaybe<Scalars['Int']['input']>;
  defaultDate?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notificationMethod?: InputMaybe<Scalars['String']['input']>;
  reportedBy?: InputMaybe<Scalars['String']['input']>;
  resolutionDate?: InputMaybe<Scalars['DateTime']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};

export type EditPdvChangeSetInput = {
  actions?: InputMaybe<Array<PdvActionInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerEmployeeId?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type EmailReceipt = {
  baristaFirstName: Scalars['String']['input'];
  destination: Scalars['String']['input'];
  lineItems: Array<EmailReceiptLine>;
  loyalty: Array<EmailReceiptLine>;
  order: EmailReceiptOrder;
  payment: Array<EmailReceiptLine>;
};

export type EmailReceiptLine = {
  index: Scalars['Int']['input'];
  left: Scalars['String']['input'];
  right: Scalars['String']['input'];
};

export type EmailReceiptOrder = {
  change: Scalars['String']['input'];
  closeTime: Scalars['String']['input'];
  number: Scalars['String']['input'];
  subtotal: Scalars['String']['input'];
  tax: Scalars['String']['input'];
  tip: Scalars['String']['input'];
  total: Scalars['String']['input'];
};

export type Employee = {
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  permissions: Array<EmployeePermission>;
  person?: Maybe<Person>;
  roles: Array<EmployeeRole>;
  stores: Array<Store>;
};


export type EmployeeStoresArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type EmployeeOrderInput = {
  items: Array<OrderItemInput>;
  termId: Scalars['Int']['input'];
};

export type EmployeePermission = {
  djangopk: Scalars['Int']['output'];
  employeeId: Scalars['ID']['output'];
  hasPermission?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  lastModified: Scalars['DateTime']['output'];
  lastModifiedStore?: Maybe<Scalars['Int']['output']>;
  lastModifiedTerm?: Maybe<Scalars['Int']['output']>;
  permission: Permission;
  permissionId: Scalars['Int']['output'];
  serverLastModified?: Maybe<Scalars['DateTime']['output']>;
};

export type EmployeeRole = {
  djangopk: Scalars['Int']['output'];
  employeeId: Scalars['ID']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  isSalaray?: Maybe<Scalars['Boolean']['output']>;
  lastModified: Scalars['DateTime']['output'];
  lastModifiedStore?: Maybe<Scalars['Int']['output']>;
  lastModifiedTerm?: Maybe<Scalars['Int']['output']>;
  role: Role;
  roleId: Scalars['Int']['output'];
  serverLastModified?: Maybe<Scalars['DateTime']['output']>;
  startDate: Scalars['DateTime']['output'];
  wage?: Maybe<Scalars['Float']['output']>;
};

export type Error = {
  asString: Scalars['String']['input'];
  componentStack: Array<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type EwardInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  birthDay?: InputMaybe<Scalars['PositiveInt']['input']>;
  birthMonth?: InputMaybe<Scalars['PositiveInt']['input']>;
  birthYear?: InputMaybe<Scalars['PositiveInt']['input']>;
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['EmailAddress']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  storeId: Scalars['Int']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type FavoriteDrink = {
  id: Scalars['ID']['output'];
  orderitem: OrderItem;
  priority: Scalars['Int']['output'];
};

export type FavoriteDrinkInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  orderitemId?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type FavoriteStore = {
  id: Scalars['ID']['output'];
  priority: Scalars['Int']['output'];
  store: Store;
};

export type FavoriteStoreInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};

export type Feedback = {
  category: Scalars['String']['output'];
  feedbackText: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type FeedbackInput = {
  category: Scalars['String']['input'];
  feedbackText: Scalars['String']['input'];
  sentryEvent?: InputMaybe<SentryEvent>;
};

export type FilterDefaultNoticeInput = {
  brandStandardViolated?: InputMaybe<Scalars['Int']['input']>;
  createdAfter?: InputMaybe<Scalars['String']['input']>;
  createdBefore?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  notificationMethod?: InputMaybe<Scalars['String']['input']>;
  reportedBy?: InputMaybe<Scalars['String']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterOrderInput = {
  employee_id?: InputMaybe<Scalars['ID']['input']>;
  hasDiscrepancy?: InputMaybe<Scalars['Boolean']['input']>;
  pickup_location?: InputMaybe<Scalars['String']['input']>;
  pickup_name?: InputMaybe<Scalars['String']['input']>;
  profile_id?: InputMaybe<Scalars['Int']['input']>;
  store_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<SessionType>;
};

/**
 * authorization is tricky here, must be done based on the specific combination of
 * ids included in this input
 *
 * a rough draft of what this might look like (based on scoping for refund
 * reporting):
 *
 * there is a limited set of valid combinations
 *
 * combo 1:
 * 	desc:
 * 		this combination can be used by terminals to listen for refund requests
 * 		and in-progress order state changes (i.e. ready, complete)
 * 	checks:
 * 		authenticated: true
 * 		authorization:
 * 			terminal session
 * 			terminal session has specified store and term id
 * 	ids:
 * 		storeId
 * 		termId
 *
 * combo 2:
 * 	desc:
 * 		this combination is for the app/perc-orders frontends to live update the
 * 		statuses of orders. this removes some of the race condition issues
 * 		on the success view
 * 	checks:
 * 		authorization:
 * 			session has specified id
 * 	ids:
 * 		sessionId
 *
 * fields not included in the above combos won't be used for now but will be good
 * to have for the future
 */
export type FilterOrderStatuses = {
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  orderId?: InputMaybe<Scalars['ID']['input']>;
  profileId?: InputMaybe<Scalars['Int']['input']>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  termId?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterPdvChangeSetInput = {
  createdAfter?: InputMaybe<Scalars['String']['input']>;
  createdBefore?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner_employee_id?: InputMaybe<Scalars['ID']['input']>;
  parent_id?: InputMaybe<Scalars['Int']['input']>;
};

export type GiftCard = {
  LastModified?: Maybe<Scalars['DateTime']['output']>;
  balance: Scalars['Int']['output'];
  cardNumber: Scalars['ID']['output'];
  id: Scalars['Int']['output'];
  intitialSaleAmount?: Maybe<Scalars['Float']['output']>;
  intitialSaleDate?: Maybe<Scalars['DateTime']['output']>;
  lastRedeemDate?: Maybe<Scalars['DateTime']['output']>;
  lastRedeemMmount?: Maybe<Scalars['Float']['output']>;
  lastSaleAmount?: Maybe<Scalars['Float']['output']>;
  lastSaleDate?: Maybe<Scalars['DateTime']['output']>;
  profileId?: Maybe<Scalars['Int']['output']>;
  tempProfileId?: Maybe<Scalars['Int']['output']>;
};

export type GiftCardPaymentInput = {
  amount: Scalars['Int']['input'];
  cardNumber: Scalars['ID']['input'];
};

export type Image = {
  altText?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  imageType?: Maybe<ImageType>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  url: Scalars['String']['output'];
};

export type ImageType =
  | 'BANNER'
  | 'ICON';

export type Item = {
  capacity?: Maybe<Scalars['Int']['output']>;
  containerId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isVariablePrice?: Maybe<Scalars['Boolean']['output']>;
  itemId: Scalars['Int']['output'];
  lastModified: Scalars['DateTime']['output'];
  prices: Array<ItemPrice>;
  product?: Maybe<Product>;
  productId?: Maybe<Scalars['Int']['output']>;
  size?: Maybe<Size>;
  sizeId?: Maybe<Scalars['Int']['output']>;
};

export type ItemPrice = {
  djangopk: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  itemId: Scalars['Int']['output'];
  lastModified: Scalars['DateTime']['output'];
  lastModifiedStore?: Maybe<Scalars['Int']['output']>;
  lastModifiedTerm?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  serverLastModified?: Maybe<Scalars['DateTime']['output']>;
  storeId: Scalars['Int']['output'];
  tierId: Scalars['Int']['output'];
};

export type LylaQuestion = {
  askAgainIfSkipped: Scalars['Boolean']['output'];
  askFrequency?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  idleTime?: Maybe<Scalars['Int']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  question: Scalars['String']['output'];
  questionId: Scalars['ID']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  whereToShow?: Maybe<Scalars['Int']['output']>;
};

export type LylaQuestionInput = {
  askAgainIfSkipped: Scalars['Boolean']['input'];
  askFrequency?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  idleTime?: InputMaybe<Scalars['Int']['input']>;
  isActive: Scalars['Boolean']['input'];
  question: Scalars['String']['input'];
  questionId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  whereToShow?: InputMaybe<Scalars['Int']['input']>;
};

export type Menu = {
  productGroups: Array<ProductGroup>;
  products: Array<Product>;
};

export type Modifier = {
  freeModId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inverseId: Scalars['Int']['output'];
  isPrintable?: Maybe<Scalars['Boolean']['output']>;
  isVariableQuantity?: Maybe<Scalars['Boolean']['output']>;
  itemName?: Maybe<Scalars['String']['output']>;
  itemNamePriority?: Maybe<Scalars['Int']['output']>;
  lastModified: Scalars['DateTime']['output'];
  modifierId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  prices: Array<ModifierPrice>;
  priority?: Maybe<Scalars['Int']['output']>;
  ticketName?: Maybe<Scalars['String']['output']>;
};

export type ModifierPrice = {
  djangopk: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  lastModified: Scalars['DateTime']['output'];
  lastModifiedStore?: Maybe<Scalars['Int']['output']>;
  lastModifiedTerm?: Maybe<Scalars['Int']['output']>;
  modifierId: Scalars['Int']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  serverLastModified?: Maybe<Scalars['DateTime']['output']>;
  storeId: Scalars['Int']['output'];
  tierId: Scalars['Int']['output'];
};

export type Mutation = {
  acceptDispute: StripeDispute;
  addCard: Profile;
  addCartItem: Cart;
  addLylaQuestion: LylaQuestion;
  applyDiscount: DiscountedOrder;
  authenticateCustomer: Customer;
  authenticateEmployee: Employee;
  authenticateLounge: Profile;
  authenticateQRCode: Session;
  changeLoungePassword: Scalars['Boolean']['output'];
  closeLoungeAccount: Scalars['Boolean']['output'];
  convertLoungeAccountToDigitalOnly: Profile;
  createBrandStandard: BrandStandard;
  createCardsInSeries: Scalars['ID']['output'];
  createDefaultNotice: DefaultNotice;
  createEwardUser: Scalars['Boolean']['output'];
  createLoungeAccount: Profile;
  createPaymentIntentLog?: Maybe<PaymentIntentLogResult>;
  createPdvChangeSet: PdvChangeSet;
  createStripeOrderPaymentIntent: StripePaymentIntentResult;
  createStripePaymentIntent: StripePaymentIntentResult;
  deleteBrandStandard: Scalars['Boolean']['output'];
  deleteCartItem: Cart;
  deleteDefaultNotice: Scalars['Boolean']['output'];
  deleteLylaQuestion: Scalars['Boolean']['output'];
  deletePdvChangeSet: Scalars['Boolean']['output'];
  editBrandStandard: BrandStandard;
  editDefaultNotice: DefaultNotice;
  editFavoriteDrinks: Array<FavoriteDrink>;
  editFavoriteStores: Array<FavoriteStore>;
  editLylaQuestion: LylaQuestion;
  editPdvChangeSet: PdvChangeSet;
  editStoreSettings: Array<Maybe<Config>>;
  logout: Scalars['Boolean']['output'];
  orderComplete: PercOrderResponse;
  orderError: PercOrderResponse;
  orderReady: PercOrderResponse;
  orderReceived: PercOrderResponse;
  percAuthenticate: PercAuthReponse;
  refund: Refund;
  refundProcessed: PercOrderResponse;
  sendCustomerOrder: Order;
  sendEmailReceipt: Scalars['Boolean']['output'];
  sendEmployeeOrder: Order;
  sendFeedback: Feedback;
  sendOrder: PercOrderResponse;
  setSessionStoreId: Session;
  submitDispute: StripeDispute;
  updateCartItem: Cart;
  updateProfile: Profile;
  upsertAddBalance?: Maybe<CardAddBalanceResult>;
};


export type MutationAcceptDisputeArgs = {
  disputeId: Scalars['String']['input'];
};


export type MutationAddCardArgs = {
  cardNumber: Scalars['String']['input'];
};


export type MutationAddCartItemArgs = {
  item: OrderItemInput;
};


export type MutationAddLylaQuestionArgs = {
  question: LylaQuestionInput;
};


export type MutationApplyDiscountArgs = {
  order: DiscountOrderInput;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAuthenticateCustomerArgs = {
  credentials: AuthenticateCustomerInput;
};


export type MutationAuthenticateEmployeeArgs = {
  credentials: AuthenticateEmployeeInput;
};


export type MutationAuthenticateLoungeArgs = {
  credentials: AuthenticateCustomerInput;
};


export type MutationAuthenticateQrCodeArgs = {
  qrcode: Scalars['String']['input'];
};


export type MutationChangeLoungePasswordArgs = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};


export type MutationCreateBrandStandardArgs = {
  brandStandard: BrandStandardInput;
};


export type MutationCreateCardsInSeriesArgs = {
  data: CreateCardsInSeriesInput;
};


export type MutationCreateDefaultNoticeArgs = {
  defaultNotice: DefaultNoticeInput;
};


export type MutationCreateEwardUserArgs = {
  ewardInput: EwardInput;
};


export type MutationCreateLoungeAccountArgs = {
  birth_date?: InputMaybe<Scalars['DateTime']['input']>;
  birthday_promotion_medium?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  eward_subscription?: InputMaybe<Scalars['Boolean']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationCreatePaymentIntentLogArgs = {
  log: PaymentIntentLog;
};


export type MutationCreatePdvChangeSetArgs = {
  changeSet: CreatePdvChangeSetInput;
};


export type MutationCreateStripeOrderPaymentIntentArgs = {
  amount: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
  order: CustomerOrderInput;
  storeId: Scalars['Int']['input'];
};


export type MutationCreateStripePaymentIntentArgs = {
  amount: Scalars['Int']['input'];
  currency: Scalars['String']['input'];
  description: Scalars['String']['input'];
  giftCardNumber: Scalars['String']['input'];
  profileId: Scalars['Int']['input'];
};


export type MutationDeleteBrandStandardArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCartItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDefaultNoticeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLylaQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePdvChangeSetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEditBrandStandardArgs = {
  brandStandard: EditBrandStandardInput;
};


export type MutationEditDefaultNoticeArgs = {
  defaultNotice: EditDefaultNoticeInput;
};


export type MutationEditFavoriteDrinksArgs = {
  favoriteDrinks: Array<FavoriteDrinkInput>;
};


export type MutationEditFavoriteStoresArgs = {
  favoriteStores: Array<FavoriteStoreInput>;
};


export type MutationEditLylaQuestionArgs = {
  question: LylaQuestionInput;
};


export type MutationEditPdvChangeSetArgs = {
  changeSet: EditPdvChangeSetInput;
  id: Scalars['ID']['input'];
};


export type MutationEditStoreSettingsArgs = {
  settings: Array<ConfigInput>;
};


export type MutationOrderCompleteArgs = {
  forced?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationOrderErrorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrderReadyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOrderReceivedArgs = {
  balance?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  pointsEarned?: InputMaybe<Scalars['Int']['input']>;
  storeId?: InputMaybe<Scalars['Int']['input']>;
  zeroedOut?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationPercAuthenticateArgs = {
  oauthToken: Scalars['String']['input'];
};


export type MutationRefundArgs = {
  orderId: Scalars['ID']['input'];
  orderItemIds: Array<Scalars['ID']['input']>;
  refundDestinations: Array<RefundDestinationInput>;
  returnReasonId: Scalars['Int']['input'];
};


export type MutationRefundProcessedArgs = {
  orderId: Scalars['ID']['input'];
  refundId: Scalars['Int']['input'];
};


export type MutationSendCustomerOrderArgs = {
  order: CustomerOrderInput;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSendEmailReceiptArgs = {
  emailReceipt: EmailReceipt;
  storeId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSendEmployeeOrderArgs = {
  order: EmployeeOrderInput;
};


export type MutationSendFeedbackArgs = {
  feedback: FeedbackInput;
};


export type MutationSendOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetSessionStoreIdArgs = {
  storeId: Scalars['Int']['input'];
};


export type MutationSubmitDisputeArgs = {
  disputeId: Scalars['String']['input'];
  evidence: StripeDisputeEvidenceInput;
  submit: Scalars['Boolean']['input'];
};


export type MutationUpdateCartItemArgs = {
  item: OrderItemInput;
};


export type MutationUpdateProfileArgs = {
  profile: ProfileInput;
};


export type MutationUpsertAddBalanceArgs = {
  cardInfo?: InputMaybe<CardAddBalanceInput>;
};

export type OnlineOrderingDiscount = {
  discountId: Scalars['Int']['output'];
  discountedItemId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  orderitemId: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  profileId: Scalars['Int']['output'];
  rewardId: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  taxRate: Scalars['Float']['output'];
};

export type OnlineProductGroup = {
  children: Array<OnlineProductGroup>;
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  images: Array<Image>;
  isVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentId: Scalars['Int']['output'];
  priority: Scalars['Int']['output'];
  productGroupId: Scalars['Int']['output'];
  products: Array<Product>;
};

export type Order = {
  appUserId?: Maybe<Scalars['Int']['output']>;
  car?: Maybe<Car>;
  cart: Cart;
  cartId: Scalars['ID']['output'];
  creditCardPayments: Array<OrderCreditCardPayment>;
  discount?: Maybe<OnlineOrderingDiscount>;
  discounts: Array<OrderDiscount>;
  discrepancy?: Maybe<Scalars['Float']['output']>;
  employee?: Maybe<Employee>;
  employeeId?: Maybe<Scalars['ID']['output']>;
  giftCardPayments: Array<OrderGiftCardPayment>;
  guestEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items: Array<OrderItem>;
  lastUpdated: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  pickupLocation: PercPickupLocation;
  pickupName: Scalars['String']['output'];
  pointsEarned: Scalars['Int']['output'];
  profile?: Maybe<Profile>;
  profileId?: Maybe<Scalars['Int']['output']>;
  refund: Refund;
  refunds: Array<Refund>;
  session: Session;
  sessionId: Scalars['ID']['output'];
  status: OrderStatus;
  statuses: Array<OrderStatus>;
  store: Store;
  storeId: Scalars['Int']['output'];
  subTotal: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  termId: Scalars['Int']['output'];
  time?: Maybe<Scalars['String']['output']>;
  timePlaced: Scalars['String']['output'];
  total: Scalars['Int']['output'];
  transaction?: Maybe<Transaction>;
  type: SessionType;
};


export type OrderRefundArgs = {
  id: Scalars['Int']['input'];
};

export type OrderCreditCardPayment = {
  amount: Scalars['Int']['output'];
  cardType?: Maybe<Scalars['String']['output']>;
  charge: StripeCharge;
  chargeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  lastFour?: Maybe<Scalars['Int']['output']>;
  order: Order;
  orderId: Scalars['ID']['output'];
};

export type OrderDirection =
  | 'asc'
  | 'desc';

export type OrderDiscount = {
  discountId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type OrderEdge = {
  cursor: Scalars['String']['output'];
  node: Order;
};

export type OrderGiftCardPayment = {
  amount: Scalars['Int']['output'];
  cardId: Scalars['Int']['output'];
  cardNumber: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type OrderItem = {
  created: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  item: Item;
  itemId: Scalars['Int']['output'];
  modifiers: Array<OrderModifier>;
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  taxRate: Scalars['Float']['output'];
  typewriterNote?: Maybe<Scalars['String']['output']>;
  updated: Scalars['String']['output'];
};

export type OrderItemInput = {
  discounted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  itemId: Scalars['Int']['input'];
  modifiers: Array<OrderModifierInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  oldPrice?: InputMaybe<Scalars['Int']['input']>;
  oldTaxAmount?: InputMaybe<Scalars['Int']['input']>;
  otterId?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Int']['input'];
  taxAmount: Scalars['Int']['input'];
  taxRate: Scalars['Float']['input'];
  typewriterNote?: InputMaybe<Scalars['String']['input']>;
};

export type OrderModifier = {
  id: Scalars['ID']['output'];
  modifier: Modifier;
  modifierId: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  quantity: Scalars['Float']['output'];
};

export type OrderModifierInput = {
  id: Scalars['ID']['input'];
  modifierId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  otterId?: InputMaybe<Scalars['String']['input']>;
  price: Scalars['Int']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderPayment = OrderCreditCardPayment | OrderGiftCardPayment;

export type OrderStatus = {
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  refundId?: Maybe<Scalars['Int']['output']>;
  status: OrderStatusEnum;
  time: Scalars['DateTime']['output'];
};

export type OrderStatusEnum =
  | 'ORDER_COMPLETE'
  | 'ORDER_ERROR'
  | 'ORDER_PROCESSING'
  | 'ORDER_READY'
  | 'ORDER_RECEIVED'
  | 'ORDER_REFUND_PROCESSED'
  | 'ORDER_REFUND_REQUESTED'
  | 'ORDER_SCHEDULED'
  | 'ORDER_SENT';

export type OrdersConnection = {
  edges: Array<OrderEdge>;
  nodes: Array<Order>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PageInfo = {
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PaymentAddBalInput = {
  creditCardPayment?: InputMaybe<CreditCardPaymentInput>;
};

export type PaymentInput = {
  creditCardPayment?: InputMaybe<CreditCardPaymentInput>;
  giftCardPayments: Array<GiftCardPaymentInput>;
};

export type PaymentIntentLog = {
  giftCardNumber?: InputMaybe<Scalars['BigInt']['input']>;
  message: Scalars['String']['input'];
  orderId?: InputMaybe<Scalars['String']['input']>;
  paymentIntent: Scalars['String']['input'];
  source: Scalars['String']['input'];
};

export type PaymentIntentLogResult = {
  status: Scalars['Boolean']['output'];
};

export type PdvAction = {
  changeSet: PdvChangeSet;
  changeSetId: Scalars['Int']['output'];
  created: Scalars['DateTime']['output'];
  data: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  owner: Employee;
  ownerEmployeeId: Scalars['ID']['output'];
  tableName: Scalars['String']['output'];
  type: PdvActionType;
};

export type PdvActionInput = {
  data?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  ownerEmployeeId?: InputMaybe<Scalars['ID']['input']>;
  tableName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PdvActionType>;
};

export type PdvActionType =
  | 'CREATE'
  | 'DELETE'
  | 'EDIT';

export type PdvChangeSet = {
  actions: Array<PdvAction>;
  children: Array<PdvChangeSet>;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  owner: Employee;
  ownerEmployeeId: Scalars['ID']['output'];
  parent?: Maybe<PdvChangeSet>;
  parentId?: Maybe<Scalars['ID']['output']>;
};

export type PdvChangeSetEdge = {
  cursor: Scalars['String']['output'];
  node: PdvChangeSet;
};

export type PdvChangeSetsConnection = {
  edges: Array<PdvChangeSetEdge>;
  nodes: Array<PdvChangeSet>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PercAuthReponse = {
  error?: Maybe<Scalars['String']['output']>;
  jwt?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PercCreditCardPayment = {
  amount: Scalars['Int']['output'];
  cardType?: Maybe<Scalars['String']['output']>;
  gratuity?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
  lastFour?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PercDiscount = {
  id: Scalars['Int']['output'];
  itemIds: Array<Scalars['Int']['output']>;
};

export type PercGiftCardPayment = {
  amount: Scalars['Int']['output'];
  cardNumber: Scalars['ID']['output'];
  gratuity?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
};

export type PercItem = {
  id: Scalars['Int']['output'];
  item?: Maybe<PercItemDetails>;
  modifiers: Array<PercModifier>;
  orderItemId: Scalars['ID']['output'];
  otterId?: Maybe<Scalars['String']['output']>;
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  taxRate: Scalars['Float']['output'];
  typewriterNote?: Maybe<Scalars['String']['output']>;
};

export type PercItemDetails = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  product?: Maybe<Product>;
  size?: Maybe<Size>;
};

export type PercModifier = {
  id: Scalars['Int']['output'];
  modifier?: Maybe<PercModifierItem>;
  orderModifierId: Scalars['ID']['output'];
  price: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
};

export type PercModifierItem = {
  name?: Maybe<Scalars['String']['output']>;
};

export type PercOrder = {
  chargeId?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<PercOrderDiscount>;
  discountAmount?: Maybe<Scalars['Int']['output']>;
  guestEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  items: Array<PercItem>;
  payments: Array<PercPayment>;
  phone?: Maybe<Scalars['String']['output']>;
  pickupLocation?: Maybe<PercPickupLocation>;
  pickupName?: Maybe<Scalars['String']['output']>;
  platformOrderId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status: OrderStatus;
  statuses: Array<OrderStatus>;
  storeId: Scalars['Int']['output'];
  subTotal: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  termId: Scalars['Int']['output'];
  time?: Maybe<Scalars['String']['output']>;
  timePlaced: Scalars['String']['output'];
  tipAmount?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
  transactionStartTime: Scalars['DateTime']['output'];
  user?: Maybe<PercUser>;
};

export type PercOrderDiscount = {
  discountId: Scalars['Int']['output'];
  discountedItemId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  onlineorderingOrderId: Scalars['String']['output'];
  orderitemId: Scalars['String']['output'];
  price: Scalars['Int']['output'];
  profileId: Scalars['Int']['output'];
  rewardId: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  taxRate: Scalars['Float']['output'];
};

export type PercOrderResponse = {
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PercPayment = PercCreditCardPayment | PercGiftCardPayment;

export type PercPickupLocation =
  | 'DRIVE_THRU'
  | 'IN_STORE'
  | 'PARKING_LOT';

export type PercUser = {
  id: Scalars['Int']['output'];
  type: PercUserType;
};

export type PercUserType =
  | 'CUSTOMER'
  | 'EMPLOYEE';

export type Permission = {
  application?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastModified: Scalars['DateTime']['output'];
  pageName?: Maybe<Scalars['String']['output']>;
  permissionId: Scalars['Int']['output'];
  permissionName?: Maybe<Scalars['String']['output']>;
};

export type Person = {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  emailAddress2?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  stores: Array<PersonStore>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type PersonStoresArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonStore = {
  id: Scalars['Int']['output'];
  percentOwnership?: Maybe<Scalars['Float']['output']>;
  primary: Scalars['Boolean']['output'];
  role: Scalars['String']['output'];
  store: Store;
};

export type Product = {
  autoModify: Scalars['Boolean']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  images: Array<Image>;
  name: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  visibility: Array<ProductVisibility>;
};

export type ProductGroup = {
  children: Array<ProductGroup>;
  id: Scalars['ID']['output'];
  isVisible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  products: Array<Product>;
};

export type ProductVisibility = {
  id: Scalars['ID']['output'];
  isVisible?: Maybe<Scalars['Boolean']['output']>;
  isVisibleOnlineOrdering: Scalars['Boolean']['output'];
  productId: Scalars['Int']['output'];
  regionId: Scalars['Int']['output'];
  storeId: Scalars['Int']['output'];
};

export type Profile = {
  birth_date?: Maybe<Scalars['String']['output']>;
  birthdayPromotionMedium?: Maybe<Scalars['String']['output']>;
  cards: Array<GiftCard>;
  cash?: Maybe<Scalars['Float']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  claimedRewards: Array<ClaimedReward>;
  email?: Maybe<Scalars['String']['output']>;
  ewardSignupDate?: Maybe<Scalars['String']['output']>;
  ewardSubscription?: Maybe<Scalars['Boolean']['output']>;
  favoriteDrinks: Array<FavoriteDrink>;
  favoriteStores: Array<FavoriteStore>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  lastModified?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  orderHistory: Array<Order>;
  phone?: Maybe<Scalars['String']['output']>;
  planProgress: Array<RewardProgress>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};


export type ProfileOrderHistoryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileInput = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  brandStandard: BrandStandard;
  brandStandards: BrandStandardsConnection;
  connections: Array<Connection>;
  defaultNotice: DefaultNotice;
  defaultNotices: DefaultNoticesConnection;
  favoriteProducts: Array<Product>;
  favoriteStores: Array<Maybe<Store>>;
  itemPrice: Array<Scalars['JSON']['output']>;
  lylaQuestion?: Maybe<LylaQuestion>;
  lylaQuestions?: Maybe<Array<LylaQuestion>>;
  /** @deprecated No longer supported */
  menu: Menu;
  missedOrders: Array<Maybe<PercOrder>>;
  missedThirdPartyOrders: Array<Maybe<PercOrder>>;
  modifierPrice: Array<Scalars['JSON']['output']>;
  onlineProductGroup: OnlineProductGroup;
  onlineProductGroups: Array<OnlineProductGroup>;
  order: Order;
  orderStatus?: Maybe<OrderStatus>;
  orders: OrdersConnection;
  pdvChangeSet: PdvChangeSet;
  pdvChangeSets: PdvChangeSetsConnection;
  pendingOrder: Order;
  pendingOrderIds: Array<Scalars['ID']['output']>;
  pendingOrders: Array<Order>;
  product?: Maybe<Product>;
  profile: Profile;
  refund: Refund;
  returnReasons: Array<ReturnReason>;
  session: Session;
  store: Store;
  stores: Array<Store>;
  storesByCity: Array<Store>;
  storesByCoordinates: Array<Store>;
  storesByZipCode: Array<Store>;
  stripeAccount: Array<StripeAccount>;
  tableVersions: Array<TableVersion>;
  tables: Tables;
  terminalCheck?: Maybe<Terminal>;
  terminals: Array<Terminal>;
  unavailableProducts: Array<ProductVisibility>;
  user?: Maybe<Customer>;
  validateCard: Scalars['Int']['output'];
  webOnlineProductGroup: OnlineProductGroup;
  webOnlineProductGroups: Array<OnlineProductGroup>;
  whereToShow?: Maybe<Array<WhereToShow>>;
};


export type QueryBrandStandardArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBrandStandardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderByMultiple?: InputMaybe<Array<Scalars['String']['input']>>;
  orderDirection?: InputMaybe<OrderDirection>;
  orderDirectionMultiple?: InputMaybe<Array<OrderDirection>>;
  useOffsetPagination?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryDefaultNoticeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDefaultNoticesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterDefaultNoticeInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderByMultiple?: InputMaybe<Array<Scalars['String']['input']>>;
  orderDirection?: InputMaybe<OrderDirection>;
  orderDirectionMultiple?: InputMaybe<Array<OrderDirection>>;
  useOffsetPagination?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFavoriteProductsArgs = {
  id: Array<Scalars['Int']['input']>;
};


export type QueryFavoriteStoresArgs = {
  storeId: Array<Scalars['Int']['input']>;
};


export type QueryItemPriceArgs = {
  storeId: Scalars['Int']['input'];
};


export type QueryLylaQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMenuArgs = {
  filterOnlineOrdering?: InputMaybe<Scalars['Boolean']['input']>;
  productGroupId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryModifierPriceArgs = {
  storeId: Scalars['Int']['input'];
};


export type QueryOnlineProductGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOnlineProductGroupsArgs = {
  parentId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOrderArgs = {
  appUserId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryOrderStatusArgs = {
  orderId: Scalars['ID']['input'];
};


export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterOrderInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderByMultiple?: InputMaybe<Array<Scalars['String']['input']>>;
  orderDirection?: InputMaybe<OrderDirection>;
  orderDirectionMultiple?: InputMaybe<Array<OrderDirection>>;
  useOffsetPagination?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPdvChangeSetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPdvChangeSetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPdvChangeSetInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderByMultiple?: InputMaybe<Array<Scalars['String']['input']>>;
  orderDirection?: InputMaybe<OrderDirection>;
  orderDirectionMultiple?: InputMaybe<Array<OrderDirection>>;
  useOffsetPagination?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPendingOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProductArgs = {
  id: Scalars['ID']['input'];
};


export type QueryProfileArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRefundArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStoreArgs = {
  storeId: Scalars['Int']['input'];
};


export type QueryStoresArgs = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  coordinates?: InputMaybe<CoordinatesInput>;
  zip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStoresByCityArgs = {
  city: Scalars['String']['input'];
};


export type QueryStoresByCoordinatesArgs = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryStoresByZipCodeArgs = {
  zip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTerminalCheckArgs = {
  storeId: Scalars['Int']['input'];
  termId: Scalars['Int']['input'];
};


export type QueryUnavailableProductsArgs = {
  storeId: Scalars['Int']['input'];
};


export type QueryValidateCardArgs = {
  cardNumber: Scalars['ID']['input'];
};


export type QueryWebOnlineProductGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWebOnlineProductGroupsArgs = {
  parentId?: InputMaybe<Scalars['Int']['input']>;
};

export type Refund = {
  created: Scalars['DateTime']['output'];
  destinations: Array<RefundDestination>;
  id: Scalars['ID']['output'];
  items: Array<OrderItem>;
  order: Order;
  orderId: Scalars['ID']['output'];
  refundId: Scalars['Int']['output'];
  returnReason: ReturnReason;
  returnReasonId: Scalars['Int']['output'];
  subTotal: Scalars['Int']['output'];
  taxAmount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  transactionStartTime: Scalars['DateTime']['output'];
};

export type RefundDestination = {
  amount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  payment: OrderPayment;
  paymentId: Scalars['ID']['output'];
  refund: Refund;
  refundDestinationId: Scalars['Int']['output'];
  refundId: Scalars['Int']['output'];
};

export type RefundDestinationInput = {
  amount: Scalars['Int']['input'];
  paymentId: Scalars['ID']['input'];
  paymentType: RefundDestinationPaymentTypeInput;
};

export type RefundDestinationPaymentTypeInput =
  | 'CREDIT_CARD'
  | 'GIFT_CARD';

export type RefundDetail = {
  guestEmail?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  pickupLocation: Scalars['String']['output'];
  pickupName: Scalars['String']['output'];
  profileId?: Maybe<Scalars['Int']['output']>;
  refund: Refund;
  storeId: Scalars['Int']['output'];
  timePlaced: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ReturnReason = {
  id: Scalars['ID']['output'];
  isVisibleOnlineOrdering: Scalars['Boolean']['output'];
  isVisiblePerc: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  returnReasonId: Scalars['Int']['output'];
  returnToInventory?: Maybe<Scalars['Boolean']['output']>;
};

export type Reward = {
  description: Scalars['String']['output'];
  expireDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  timeLimit?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
  validEverywhere: Scalars['Boolean']['output'];
  validLocations: Array<Store>;
};

export type RewardPlan = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  reward: Reward;
  rewardId: Scalars['Int']['output'];
  threshold: Scalars['Float']['output'];
};

export type RewardProgress = {
  id: Scalars['Int']['output'];
  lastModified: Scalars['DateTime']['output'];
  plan: RewardPlan;
  points: Scalars['Float']['output'];
  profile: Profile;
  profileId: Scalars['Int']['output'];
  rewardPlanId: Scalars['Int']['output'];
};

export type Role = {
  id: Scalars['Int']['output'];
  lastModified: Scalars['DateTime']['output'];
  name?: Maybe<Scalars['String']['output']>;
  permissions: Array<Permission>;
  roleId: Scalars['Int']['output'];
};

export type SentryEvent = {
  error: Error;
  eventId: Scalars['String']['input'];
};

export type Session = {
  authenticated: Scalars['Boolean']['output'];
  cart: Cart;
  customer?: Maybe<Customer>;
  employee?: Maybe<Employee>;
  id: Scalars['ID']['output'];
  order?: Maybe<Order>;
  profile?: Maybe<Profile>;
  store?: Maybe<Store>;
  type: SessionType;
};


export type SessionOrderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type SessionType =
  | 'APP_USER'
  | 'BHLOUNGE'
  | 'EMPLOYEE';

export type Size = {
  id: Scalars['ID']['output'];
  itemName: Scalars['String']['output'];
  itemNamePriority: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
};

export type Store = {
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  disputes: Array<StripeDispute>;
  distance?: Maybe<Scalars['Float']['output']>;
  driveThru?: Maybe<Scalars['Boolean']['output']>;
  driveThruPickup: Scalars['Boolean']['output'];
  facebookUrl?: Maybe<Scalars['String']['output']>;
  friClose?: Maybe<Scalars['String']['output']>;
  friOpen?: Maybe<Scalars['String']['output']>;
  inStorePickup: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  monThruThursClose?: Maybe<Scalars['String']['output']>;
  monThruThursOpen?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  oLOEnabled?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Order>;
  orders: OrdersConnection;
  parkingLotPickup: Scalars['Boolean']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  priceTierId?: Maybe<Scalars['Int']['output']>;
  pricingTier?: Maybe<Scalars['String']['output']>;
  regionId?: Maybe<Scalars['Int']['output']>;
  satClose?: Maybe<Scalars['String']['output']>;
  satOpen?: Maybe<Scalars['String']['output']>;
  settings: Array<Config>;
  state?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  storeId: Scalars['Int']['output'];
  storeType?: Maybe<Scalars['String']['output']>;
  stripeAccount?: Maybe<StripeAccount>;
  sunClose?: Maybe<Scalars['String']['output']>;
  sunOpen?: Maybe<Scalars['String']['output']>;
  terminals: Array<Terminal>;
  timeZone: Scalars['String']['output'];
  twitterUrl?: Maybe<Scalars['String']['output']>;
  wiFi?: Maybe<Scalars['Boolean']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type StoreDisputesArgs = {
  endingBefore?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  startingAfter?: InputMaybe<Scalars['String']['input']>;
};


export type StoreOrderArgs = {
  id: Scalars['ID']['input'];
};


export type StoreOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterOrderInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderByMultiple?: InputMaybe<Array<Scalars['String']['input']>>;
  orderDirection?: InputMaybe<OrderDirection>;
  orderDirectionMultiple?: InputMaybe<Array<OrderDirection>>;
  useOffsetPagination?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StoreAvailability = {
  available: Scalars['Boolean']['output'];
  created: Scalars['DateTime']['output'];
  deleted: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  storeId: Scalars['Int']['output'];
  updated: Scalars['DateTime']['output'];
};

export type StripeAccount = {
  accountId: Scalars['ID']['output'];
  chargesEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  loginUrl?: Maybe<Scalars['String']['output']>;
  onboardingUrl?: Maybe<Scalars['String']['output']>;
  storeId?: Maybe<Scalars['Int']['output']>;
};

export type StripeCard = {
  brand?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  expMonth: Scalars['Int']['output'];
  expYear: Scalars['Int']['output'];
  fingerprint: Scalars['ID']['output'];
  funding: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
  network: Scalars['String']['output'];
};

export type StripeCharge = {
  amount: Scalars['Int']['output'];
  amountCaptured: Scalars['Int']['output'];
  amountRefunded: Scalars['Int']['output'];
  captured: Scalars['Boolean']['output'];
  created: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<StripeAccount>;
  destinationId?: Maybe<Scalars['String']['output']>;
  dispute?: Maybe<StripeDispute>;
  disputeId?: Maybe<Scalars['String']['output']>;
  disputed: Scalars['Boolean']['output'];
  fee?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  net?: Maybe<Scalars['Int']['output']>;
  outcome?: Maybe<StripeChargeOutcome>;
  paid: Scalars['Boolean']['output'];
  payment?: Maybe<OrderCreditCardPayment>;
  paymentMethod?: Maybe<StripeCard>;
  paymentMethodId: Scalars['String']['output'];
  receiptUrl?: Maybe<Scalars['String']['output']>;
  refunded: Scalars['Boolean']['output'];
  refunds: StripeRefundList;
  source?: Maybe<StripeCard>;
  sourceId?: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  transfer?: Maybe<StripeTransfer>;
  transferId?: Maybe<Scalars['ID']['output']>;
};

export type StripeChargeOutcome = {
  networkStatus?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  riskLevel?: Maybe<Scalars['String']['output']>;
  riskScore?: Maybe<Scalars['Int']['output']>;
  sellerMessage?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type StripeDispute = {
  amount: Scalars['Int']['output'];
  charge?: Maybe<StripeCharge>;
  chargeId: Scalars['ID']['output'];
  created: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  evidence?: Maybe<StripeDisputeEvidence>;
  evidenceDetails?: Maybe<StripeEvidenceDetails>;
  fee?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isChargeRefundable: Scalars['Boolean']['output'];
  net?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  status: Scalars['String']['output'];
  storeId?: Maybe<Scalars['Int']['output']>;
};

export type StripeDisputeEvidence = {
  accessActivityLog?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<Scalars['String']['output']>;
  cancellationPolicy?: Maybe<Scalars['String']['output']>;
  cancellationPolicyDisclosure?: Maybe<Scalars['String']['output']>;
  cancellationRebuttal?: Maybe<Scalars['String']['output']>;
  customerCommunication?: Maybe<Scalars['String']['output']>;
  customerEmailAddress?: Maybe<Scalars['String']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  customerPurchaseIp?: Maybe<Scalars['String']['output']>;
  customerSignature?: Maybe<Scalars['String']['output']>;
  duplicateChargeDocumentation?: Maybe<Scalars['String']['output']>;
  duplicateChargeExplanation?: Maybe<Scalars['String']['output']>;
  duplicateChargeId?: Maybe<Scalars['String']['output']>;
  productDescription?: Maybe<Scalars['String']['output']>;
  receipt?: Maybe<Scalars['String']['output']>;
  refundPolicy?: Maybe<Scalars['String']['output']>;
  refundPolicyDisclosure?: Maybe<Scalars['String']['output']>;
  refundRefusalExplanation?: Maybe<Scalars['String']['output']>;
  serviceDate?: Maybe<Scalars['String']['output']>;
  serviceDocumentation?: Maybe<Scalars['String']['output']>;
  uncategorizedFile?: Maybe<Scalars['String']['output']>;
  uncategorizedText?: Maybe<Scalars['String']['output']>;
};

export type StripeDisputeEvidenceInput = {
  accessActivityLog?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  cancellationPolicy?: InputMaybe<Scalars['String']['input']>;
  cancellationPolicyDisclosure?: InputMaybe<Scalars['String']['input']>;
  cancellationRebuttal?: InputMaybe<Scalars['String']['input']>;
  customerCommunication?: InputMaybe<Scalars['String']['input']>;
  customerEmailAddress?: InputMaybe<Scalars['String']['input']>;
  customerName?: InputMaybe<Scalars['String']['input']>;
  customerPurchaseIp?: InputMaybe<Scalars['String']['input']>;
  customerSignature?: InputMaybe<Scalars['String']['input']>;
  duplicateChargeDocumentation?: InputMaybe<Scalars['String']['input']>;
  duplicateChargeExplanation?: InputMaybe<Scalars['String']['input']>;
  duplicateChargeId?: InputMaybe<Scalars['String']['input']>;
  productDescription?: InputMaybe<Scalars['String']['input']>;
  receipt?: InputMaybe<Scalars['String']['input']>;
  refundPolicy?: InputMaybe<Scalars['String']['input']>;
  refundPolicyDisclosure?: InputMaybe<Scalars['String']['input']>;
  refundRefusalExplanation?: InputMaybe<Scalars['String']['input']>;
  serviceDate?: InputMaybe<Scalars['String']['input']>;
  serviceDocumentation?: InputMaybe<Scalars['String']['input']>;
  uncategorizedFile?: InputMaybe<Scalars['String']['input']>;
  uncategorizedText?: InputMaybe<Scalars['String']['input']>;
};

export type StripeEvidenceDetails = {
  dueBy: Scalars['String']['output'];
  hasEvidence: Scalars['Boolean']['output'];
  pastDue: Scalars['Boolean']['output'];
  submissionCount: Scalars['Int']['output'];
};

export type StripeRefund = {
  amount: Scalars['Int']['output'];
  created: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  object: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  receiptNumber?: Maybe<Scalars['String']['output']>;
  sourceTransferReversal?: Maybe<StripeTransfer>;
  transferReversal?: Maybe<StripeTransfer>;
};

export type StripeRefundList = {
  data: Array<StripeRefund>;
  hasMore: Scalars['Boolean']['output'];
  totalCount: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type StripeTransfer = {
  amount?: Maybe<Scalars['Int']['output']>;
  destination: StripeAccount;
  group: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type Subscription = {
  allOrders?: Maybe<PercOrder>;
  createCardsInSeriesUpdates: CreateCardsInSeriesUpdate;
  logs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  newOrder: PercOrder;
  orderStatus?: Maybe<OrderStatus>;
  orderStatuses: OrderStatus;
  orders: Array<PercOrder>;
  otterOrder: PercOrder;
  refundRequest: RefundDetail;
  terminals: Array<Terminal>;
};


export type SubscriptionCreateCardsInSeriesUpdatesArgs = {
  executionArn: Scalars['ID']['input'];
};


export type SubscriptionOrderStatusArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionOrderStatusesArgs = {
  filter: FilterOrderStatuses;
};


export type SubscriptionTerminalsArgs = {
  storeId?: InputMaybe<Scalars['Int']['input']>;
};

export type TableName =
  | 'componentGroupRatioQuantities'
  | 'componentGroupRatioType'
  | 'componentGroupRatioTypeItemQualifiers'
  | 'componentGroupRatios'
  | 'componentGroupRatiosItemQualifiers'
  | 'componentGroups'
  | 'componentQualifiers'
  | 'componentUnitRatios'
  | 'componentVersions'
  | 'components'
  | 'componentsComponentGroups'
  | 'componentsModifiers'
  | 'containerVolumes'
  | 'containers'
  | 'inventoryItems'
  | 'itemPrices'
  | 'itemQualifiers'
  | 'items'
  | 'itemsComponents'
  | 'modifierFunctions'
  | 'modifierFunctionsItemQualifiers'
  | 'modifierGroups'
  | 'modifierGroupsItemQualifiers'
  | 'modifierGroupsModifiers'
  | 'modifierPrices'
  | 'modifierScales'
  | 'modifierScalesItemQualifiers'
  | 'modifierScalesModifiers'
  | 'modifierVisibility'
  | 'modifiers'
  | 'modifiersItemQualifiers'
  | 'productGroups'
  | 'productGroupsProducts'
  | 'productVersions'
  | 'productVisibility'
  | 'products'
  | 'sizes'
  | 'stateLocale'
  | 'taxLocal'
  | 'taxState'
  | 'units';

export type TableVersion = {
  tableName: TableName;
  version: Scalars['DateTime']['output'];
};

export type Tables = {
  config: Array<ConfigTable>;
  itemPrices: Array<Scalars['JSON']['output']>;
  modifierPrices: Array<Scalars['JSON']['output']>;
};


export type TablesConfigArgs = {
  storeId?: InputMaybe<Scalars['Int']['input']>;
};

export type Terminal = {
  connectionId?: Maybe<Scalars['ID']['output']>;
  status: TerminalStatus;
  storeId: Scalars['Int']['output'];
  termId: Scalars['Int']['output'];
  time: Scalars['String']['output'];
};

export type TerminalStatus =
  | 'CONNECTED'
  | 'DISCONNECTED';

export type TransItem = {
  aggregated?: Maybe<Scalars['Boolean']['output']>;
  discountAddTime?: Maybe<Scalars['DateTime']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  includeInSales?: Maybe<Scalars['Boolean']['output']>;
  isVoided?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Item>;
  itemAddDate?: Maybe<Scalars['Int']['output']>;
  itemAddTime: Scalars['DateTime']['output'];
  itemId?: Maybe<Scalars['Int']['output']>;
  lastModified: Scalars['DateTime']['output'];
  modifiers: Array<TransModifier>;
  price?: Maybe<Scalars['Float']['output']>;
  return?: Maybe<Scalars['Boolean']['output']>;
  returnReason?: Maybe<ReturnReason>;
  returnReasonId?: Maybe<Scalars['Int']['output']>;
  serverLastModified?: Maybe<Scalars['DateTime']['output']>;
  storeId: Scalars['Int']['output'];
  taxAmount?: Maybe<Scalars['Float']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  termId: Scalars['Int']['output'];
  ticketName?: Maybe<Scalars['String']['output']>;
  transStartTime: Scalars['DateTime']['output'];
  typewriterNote?: Maybe<Scalars['String']['output']>;
  void?: Maybe<TransItemVoid>;
};

export type TransItemVoid = {
  aggregated?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  itemAddTime: Scalars['DateTime']['output'];
  lastModified: Scalars['DateTime']['output'];
  storeId: Scalars['Int']['output'];
  termId: Scalars['Int']['output'];
  transStartTime: Scalars['DateTime']['output'];
  voidReasonId?: Maybe<Scalars['Int']['output']>;
  voidTime?: Maybe<Scalars['DateTime']['output']>;
};

export type TransModifier = {
  aggregated?: Maybe<Scalars['Boolean']['output']>;
  basePrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isVoided?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<TransItem>;
  itemAddTime?: Maybe<Scalars['DateTime']['output']>;
  lastModified: Scalars['DateTime']['output'];
  modifier: Modifier;
  modifierAddTime: Scalars['DateTime']['output'];
  modifierId: Scalars['Int']['output'];
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  returnReason?: Maybe<ReturnReason>;
  returnReasonId?: Maybe<Scalars['Int']['output']>;
  serverLastModified?: Maybe<Scalars['DateTime']['output']>;
  storeId: Scalars['Int']['output'];
  termId: Scalars['Int']['output'];
  transStartTime: Scalars['DateTime']['output'];
};

export type Transaction = {
  aggregated?: Maybe<Scalars['Boolean']['output']>;
  cashier?: Maybe<Employee>;
  cashierId?: Maybe<Scalars['ID']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  grossPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isDigitalOrder?: Maybe<Scalars['Boolean']['output']>;
  items: Array<TransItem>;
  lastModified: Scalars['DateTime']['output'];
  netPrice?: Maybe<Scalars['Float']['output']>;
  nonSaleRevenue?: Maybe<Scalars['Float']['output']>;
  onlineOrder?: Maybe<Order>;
  onlineOrderId?: Maybe<Scalars['ID']['output']>;
  onlineTimePlaced?: Maybe<Scalars['DateTime']['output']>;
  open?: Maybe<Scalars['Boolean']['output']>;
  orderNumber?: Maybe<Scalars['Int']['output']>;
  pickupLocation?: Maybe<Scalars['String']['output']>;
  pickupName?: Maybe<Scalars['String']['output']>;
  serverLastModified: Scalars['DateTime']['output'];
  storeId: Scalars['Int']['output'];
  tax?: Maybe<Scalars['Float']['output']>;
  taxExempt?: Maybe<Scalars['Boolean']['output']>;
  termId: Scalars['Int']['output'];
  tillId: Scalars['Int']['output'];
  transCloseTime?: Maybe<Scalars['DateTime']['output']>;
  transStartTime: Scalars['DateTime']['output'];
  wasZeroedOut?: Maybe<Scalars['Boolean']['output']>;
};

export type WhereToShow = {
  lastModified?: Maybe<Scalars['DateTime']['output']>;
  questionLocationId: Scalars['Int']['output'];
  screenname: Scalars['String']['output'];
};

export type StripePaymentIntentResult = {
  clientSecret: Scalars['String']['output'];
  id: Scalars['String']['output'];
  paymentIntentId: Scalars['String']['output'];
};

export type OnlineProductGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OnlineProductGroupQuery = { onlineProductGroup: { id: string, name: string, children: Array<{ id: string, name: string, image: string, isVisible: boolean }>, products: Array<{ icon: string, priority?: number | null, id: string, name: string, visibility: Array<{ storeId: number, regionId: number, isVisible?: boolean | null, isVisibleOnlineOrdering: boolean }> }> } };

export type OnlineProductGroupsQueryVariables = Exact<{
  parentId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OnlineProductGroupsQuery = { onlineProductGroups: Array<{ id: string, name: string, image: string, isVisible: boolean }> };

export type WebOnlineProductGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WebOnlineProductGroupQuery = { webOnlineProductGroup: { id: string, name: string, children: Array<{ id: string, name: string, image: string, isVisible: boolean }>, products: Array<{ icon: string, priority?: number | null, id: string, name: string, visibility: Array<{ storeId: number, regionId: number, isVisible?: boolean | null, isVisibleOnlineOrdering: boolean }> }> } };

export type WebOnlineProductGroupsQueryVariables = Exact<{
  parentId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WebOnlineProductGroupsQuery = { webOnlineProductGroups: Array<{ id: string, name: string, image: string, isVisible: boolean }> };

export type CartFieldsFragment = { id: string, items: Array<{ id: string, quantity: number, price: number, taxAmount: number, taxRate: number, typewriterNote?: string | null, item: { id: string, size?: { id: string, name: string } | null, product?: { id: string, name: string } | null }, modifiers: Array<{ id: string, quantity: number, price: number, modifier: { id: string, name?: string | null, isVariableQuantity?: boolean | null, priority?: number | null } }> }> };

export type ConfigFieldsFragment = { storeId: number, termId: number, setting: string, value: string };

export type FavoriteDrinkFieldsFragment = { id: string, priority: number, orderitem: { id: string, quantity: number, price: number, taxAmount: number, taxRate: number, typewriterNote?: string | null, item: { id: string, size?: { id: string, name: string } | null, product?: { id: string, name: string } | null }, modifiers: Array<{ id: string, quantity: number, price: number, modifier: { id: string, name?: string | null, isVariableQuantity?: boolean | null, priority?: number | null } }> } };

export type FavoriteStoreFieldsFragment = { id: string, priority: number, store: { storeId: number, regionId?: number | null, nickname?: string | null, phone?: string | null, driveThru?: boolean | null, monThruThursOpen?: string | null, monThruThursClose?: string | null, friOpen?: string | null, friClose?: string | null, satOpen?: string | null, satClose?: string | null, sunOpen?: string | null, sunClose?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, location?: string | null, latitude?: number | null, longitude?: number | null, wiFi?: boolean | null, twitterUrl?: string | null, facebookUrl?: string | null, distance?: number | null, pricingTier?: string | null, timeZone: string, oLOEnabled?: boolean | null } };

export type OrderCreditCardPaymentFieldsFragment = { id: string, chargeId: string, amount: number, identifier?: string | null, cardType?: string | null, lastFour?: number | null };

export type OrderFieldsFragment = { id: string, timePlaced: string, lastUpdated: string, time?: string | null, cartId: string, storeId: number, termId: number, profileId?: number | null, subTotal: number, taxAmount: number, total: number, guestEmail?: string | null, pickupName: string, pickupLocation: PercPickupLocation, pointsEarned: number, profile?: { firstName: string, lastName: string } | null, car?: { year?: number | null, make: string, model: string, color: string } | null, store: { storeId: number, regionId?: number | null, nickname?: string | null, phone?: string | null, driveThru?: boolean | null, monThruThursOpen?: string | null, monThruThursClose?: string | null, friOpen?: string | null, friClose?: string | null, satOpen?: string | null, satClose?: string | null, sunOpen?: string | null, sunClose?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, location?: string | null, latitude?: number | null, longitude?: number | null, wiFi?: boolean | null, twitterUrl?: string | null, facebookUrl?: string | null, distance?: number | null, pricingTier?: string | null, timeZone: string, oLOEnabled?: boolean | null }, creditCardPayments: Array<{ id: string, amount: number, identifier?: string | null, cardType?: string | null, lastFour?: number | null }>, giftCardPayments: Array<{ id: string, cardId: number, cardNumber: string, amount: number }>, discounts: Array<{ id: string, discountId: number }>, status: { id: number, orderId: string, status: OrderStatusEnum, details?: string | null, time: string }, items: Array<{ id: string, quantity: number, price: number, taxAmount: number, taxRate: number, typewriterNote?: string | null, item: { id: string, size?: { id: string, name: string } | null, product?: { id: string, name: string } | null }, modifiers: Array<{ id: string, quantity: number, price: number, modifier: { id: string, name?: string | null, isVariableQuantity?: boolean | null, priority?: number | null } }> }>, refunds: Array<{ id: string, refundId: number, orderId: string, returnReasonId: number, created: string, returnReason: { id: string, returnReasonId: number, name?: string | null, returnToInventory?: boolean | null, isVisiblePerc: boolean, isVisibleOnlineOrdering: boolean }, items: Array<{ id: string, quantity: number, price: number, taxAmount: number, taxRate: number, typewriterNote?: string | null, item: { id: string, size?: { id: string, name: string } | null, product?: { id: string, name: string } | null }, modifiers: Array<{ id: string, quantity: number, price: number, modifier: { id: string, name?: string | null, isVariableQuantity?: boolean | null, priority?: number | null } }> }>, destinations: Array<{ id: string, refundDestinationId: number, amount: number, refundId: number, paymentId: string, payment: { id: string, chargeId: string, amount: number, identifier?: string | null, cardType?: string | null, lastFour?: number | null } | { id: string, cardId: number, cardNumber: string, amount: number } }> }> };

export type OrderGiftCardPaymentFieldsFragment = { id: string, cardId: number, cardNumber: string, amount: number };

export type OrderItemFieldsFragment = { id: string, quantity: number, price: number, taxAmount: number, taxRate: number, typewriterNote?: string | null, item: { id: string, size?: { id: string, name: string } | null, product?: { id: string, name: string } | null }, modifiers: Array<{ id: string, quantity: number, price: number, modifier: { id: string, name?: string | null, isVariableQuantity?: boolean | null, priority?: number | null } }> };

export type OrderStatusFieldsFragment = { id: number, orderId: string, status: OrderStatusEnum, details?: string | null, time: string };

export type ProductFieldsFragment = { id: string, name: string, icon: string, visibility: Array<{ storeId: number, regionId: number, isVisible?: boolean | null, isVisibleOnlineOrdering: boolean }> };

export type OnlineProductGroupFieldsFragment = { id: string, parentId: number, isVisible: boolean };

export type ProfileFieldsFragment = { id: number, email?: string | null, firstName: string, lastName: string, cash?: number | null, unit?: string | null, street?: string | null, city?: string | null, state?: string | null, postal_code?: string | null, phone?: string | null, birth_date?: string | null, gender?: string | null, birthdayPromotionMedium?: string | null, ewardSubscription?: boolean | null, ewardSignupDate?: string | null, lastModified?: string | null, cards: Array<{ cardNumber: string, balance: number }>, orderHistory: Array<{ id: string, timePlaced: string, lastUpdated: string, time?: string | null, cartId: string, storeId: number, termId: number, profileId?: number | null, subTotal: number, taxAmount: number, total: number, guestEmail?: string | null, pickupName: string, pickupLocation: PercPickupLocation, pointsEarned: number, profile?: { firstName: string, lastName: string } | null, car?: { year?: number | null, make: string, model: string, color: string } | null, store: { storeId: number, regionId?: number | null, nickname?: string | null, phone?: string | null, driveThru?: boolean | null, monThruThursOpen?: string | null, monThruThursClose?: string | null, friOpen?: string | null, friClose?: string | null, satOpen?: string | null, satClose?: string | null, sunOpen?: string | null, sunClose?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, location?: string | null, latitude?: number | null, longitude?: number | null, wiFi?: boolean | null, twitterUrl?: string | null, facebookUrl?: string | null, distance?: number | null, pricingTier?: string | null, timeZone: string, oLOEnabled?: boolean | null }, creditCardPayments: Array<{ id: string, amount: number, identifier?: string | null, cardType?: string | null, lastFour?: number | null }>, giftCardPayments: Array<{ id: string, cardId: number, cardNumber: string, amount: number }>, discounts: Array<{ id: string, discountId: number }>, status: { id: number, orderId: string, status: OrderStatusEnum, details?: string | null, time: string }, items: Array<{ id: string, quantity: number, price: number, taxAmount: number, taxRate: number, typewriterNote?: string | null, item: { id: string, size?: { id: string, name: string } | null, product?: { id: string, name: string } | null }, modifiers: Array<{ id: string, quantity: number, price: number, modifier: { id: string, name?: string | null, isVariableQuantity?: boolean | null, priority?: number | null } }> }>, refunds: Array<{ id: string, refundId: number, orderId: string, returnReasonId: number, created: string, returnReason: { id: string, returnReasonId: number, name?: string | null, returnToInventory?: boolean | null, isVisiblePerc: boolean, isVisibleOnlineOrdering: boolean }, items: Array<{ id: string, quantity: number, price: number, taxAmount: number, taxRate: number, typewriterNote?: string | null, item: { id: string, size?: { id: string, name: string } | null, product?: { id: string, name: string } | null }, modifiers: Array<{ id: string, quantity: number, price: number, modifier: { id: string, name?: string | null, isVariableQuantity?: boolean | null, priority?: number | null } }> }>, destinations: Array<{ id: string, refundDestinationId: number, amount: number, refundId: number, paymentId: string, payment: { id: string, chargeId: string, amount: number, identifier?: string | null, cardType?: string | null, lastFour?: number | null } | { id: string, cardId: number, cardNumber: string, amount: number } }> }> }> };

export type RefundDestinationFieldsFragment = { id: string, refundDestinationId: number, amount: number, refundId: number, paymentId: string, payment: { id: string, chargeId: string, amount: number, identifier?: string | null, cardType?: string | null, lastFour?: number | null } | { id: string, cardId: number, cardNumber: string, amount: number } };

export type RefundFieldsFragment = { id: string, refundId: number, orderId: string, returnReasonId: number, created: string, returnReason: { id: string, returnReasonId: number, name?: string | null, returnToInventory?: boolean | null, isVisiblePerc: boolean, isVisibleOnlineOrdering: boolean }, items: Array<{ id: string, quantity: number, price: number, taxAmount: number, taxRate: number, typewriterNote?: string | null, item: { id: string, size?: { id: string, name: string } | null, product?: { id: string, name: string } | null }, modifiers: Array<{ id: string, quantity: number, price: number, modifier: { id: string, name?: string | null, isVariableQuantity?: boolean | null, priority?: number | null } }> }>, destinations: Array<{ id: string, refundDestinationId: number, amount: number, refundId: number, paymentId: string, payment: { id: string, chargeId: string, amount: number, identifier?: string | null, cardType?: string | null, lastFour?: number | null } | { id: string, cardId: number, cardNumber: string, amount: number } }> };

export type ReturnReasonFieldsFragment = { id: string, returnReasonId: number, name?: string | null, returnToInventory?: boolean | null, isVisiblePerc: boolean, isVisibleOnlineOrdering: boolean };

export type SessionUserGiftCardsFieldsFragment = { cardNumber: string, balance: number };

export type StoreFieldsFragment = { storeId: number, regionId?: number | null, nickname?: string | null, phone?: string | null, driveThru?: boolean | null, monThruThursOpen?: string | null, monThruThursClose?: string | null, friOpen?: string | null, friClose?: string | null, satOpen?: string | null, satClose?: string | null, sunOpen?: string | null, sunClose?: string | null, address1?: string | null, address2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null, location?: string | null, latitude?: number | null, longitude?: number | null, wiFi?: boolean | null, twitterUrl?: string | null, facebookUrl?: string | null, distance?: number | null, pricingTier?: string | null, timeZone: string, oLOEnabled?: boolean | null };

export type StorePickupFieldsFragment = { storeId: number, inStorePickup: boolean, driveThruPickup: boolean, parkingLotPickup: boolean, terminals: Array<{ storeId: number, termId: number, status: TerminalStatus }> };

export type TerminalFieldsFragment = { storeId: number, termId: number, status: TerminalStatus };

export const namedOperations = {
  Query: {
    OnlineProductGroup: 'OnlineProductGroup',
    OnlineProductGroups: 'OnlineProductGroups',
    WebOnlineProductGroup: 'WebOnlineProductGroup',
    WebOnlineProductGroups: 'WebOnlineProductGroups'
  },
  Fragment: {
    cartFields: 'cartFields',
    configFields: 'configFields',
    favoriteDrinkFields: 'favoriteDrinkFields',
    favoriteStoreFields: 'favoriteStoreFields',
    orderCreditCardPaymentFields: 'orderCreditCardPaymentFields',
    orderFields: 'orderFields',
    orderGiftCardPaymentFields: 'orderGiftCardPaymentFields',
    orderItemFields: 'orderItemFields',
    orderStatusFields: 'orderStatusFields',
    productFields: 'productFields',
    onlineProductGroupFields: 'onlineProductGroupFields',
    profileFields: 'profileFields',
    refundDestinationFields: 'refundDestinationFields',
    refundFields: 'refundFields',
    returnReasonFields: 'returnReasonFields',
    sessionUserGiftCardsFields: 'sessionUserGiftCardsFields',
    storeFields: 'storeFields',
    storePickupFields: 'storePickupFields',
    terminalFields: 'terminalFields'
  }
}
export const OrderItemFieldsFragmentDoc = gql`
    fragment orderItemFields on OrderItem {
  id
  quantity
  price
  taxAmount
  taxRate
  typewriterNote
  item {
    id
    size {
      id
      name
    }
    product {
      id
      name
    }
  }
  modifiers {
    id
    quantity
    price
    modifier {
      id
      name
      isVariableQuantity
      priority
    }
  }
}
    `;
export const CartFieldsFragmentDoc = gql`
    fragment cartFields on Cart {
  id
  items {
    ...orderItemFields
  }
}
    ${OrderItemFieldsFragmentDoc}`;
export const ConfigFieldsFragmentDoc = gql`
    fragment configFields on ConfigTable {
  storeId
  termId
  setting
  value
}
    `;
export const FavoriteDrinkFieldsFragmentDoc = gql`
    fragment favoriteDrinkFields on FavoriteDrink {
  id
  orderitem {
    ...orderItemFields
  }
  priority
}
    ${OrderItemFieldsFragmentDoc}`;
export const StoreFieldsFragmentDoc = gql`
    fragment storeFields on Store {
  storeId
  regionId
  nickname
  phone
  driveThru
  monThruThursOpen
  monThruThursClose
  friOpen
  friClose
  satOpen
  satClose
  sunOpen
  sunClose
  address1
  address2
  city
  state
  zipCode
  location
  latitude
  longitude
  wiFi
  twitterUrl
  facebookUrl
  distance
  pricingTier
  timeZone
  distance
  oLOEnabled
}
    `;
export const FavoriteStoreFieldsFragmentDoc = gql`
    fragment favoriteStoreFields on FavoriteStore {
  id
  store {
    ...storeFields
  }
  priority
}
    ${StoreFieldsFragmentDoc}`;
export const ProductFieldsFragmentDoc = gql`
    fragment productFields on Product {
  id
  name
  icon
  visibility {
    storeId
    regionId
    isVisible
    isVisibleOnlineOrdering
  }
}
    `;
export const OnlineProductGroupFieldsFragmentDoc = gql`
    fragment onlineProductGroupFields on OnlineProductGroup {
  id
  parentId
  isVisible
}
    `;
export const OrderStatusFieldsFragmentDoc = gql`
    fragment orderStatusFields on OrderStatus {
  id
  orderId
  status
  details
  time
}
    `;
export const ReturnReasonFieldsFragmentDoc = gql`
    fragment returnReasonFields on ReturnReason {
  id
  returnReasonId
  name
  returnToInventory
  isVisiblePerc
  isVisibleOnlineOrdering
}
    `;
export const OrderGiftCardPaymentFieldsFragmentDoc = gql`
    fragment orderGiftCardPaymentFields on OrderGiftCardPayment {
  id
  cardId
  cardNumber
  amount
}
    `;
export const OrderCreditCardPaymentFieldsFragmentDoc = gql`
    fragment orderCreditCardPaymentFields on OrderCreditCardPayment {
  id
  chargeId
  amount
  identifier
  cardType
  lastFour
}
    `;
export const RefundDestinationFieldsFragmentDoc = gql`
    fragment refundDestinationFields on RefundDestination {
  id
  refundDestinationId
  amount
  refundId
  paymentId
  payment {
    ... on OrderGiftCardPayment {
      ...orderGiftCardPaymentFields
    }
    ... on OrderCreditCardPayment {
      ...orderCreditCardPaymentFields
    }
  }
}
    ${OrderGiftCardPaymentFieldsFragmentDoc}
${OrderCreditCardPaymentFieldsFragmentDoc}`;
export const RefundFieldsFragmentDoc = gql`
    fragment refundFields on Refund {
  id
  refundId
  orderId
  returnReasonId
  returnReason {
    ...returnReasonFields
  }
  items {
    ...orderItemFields
  }
  destinations {
    ...refundDestinationFields
  }
  created
}
    ${ReturnReasonFieldsFragmentDoc}
${OrderItemFieldsFragmentDoc}
${RefundDestinationFieldsFragmentDoc}`;
export const OrderFieldsFragmentDoc = gql`
    fragment orderFields on Order {
  id
  timePlaced
  lastUpdated
  time
  cartId
  storeId
  termId
  profileId
  subTotal
  taxAmount
  total
  profile {
    firstName
    lastName
  }
  guestEmail
  pickupName
  pickupLocation
  car {
    year
    make
    model
    color
  }
  store {
    ...storeFields
  }
  creditCardPayments {
    id
    amount
    identifier
    cardType
    lastFour
  }
  giftCardPayments {
    id
    cardId
    cardNumber
    amount
  }
  discounts {
    id
    discountId
  }
  status {
    ...orderStatusFields
  }
  items {
    ...orderItemFields
  }
  pointsEarned
  refunds {
    ...refundFields
  }
}
    ${StoreFieldsFragmentDoc}
${OrderStatusFieldsFragmentDoc}
${OrderItemFieldsFragmentDoc}
${RefundFieldsFragmentDoc}`;
export const ProfileFieldsFragmentDoc = gql`
    fragment profileFields on Profile {
  id
  email
  firstName
  lastName
  cash
  unit
  street
  city
  state
  postal_code
  phone
  birth_date
  gender
  birthdayPromotionMedium
  ewardSubscription
  ewardSignupDate
  lastModified
  cards {
    cardNumber
    balance
  }
  orderHistory {
    ...orderFields
  }
}
    ${OrderFieldsFragmentDoc}`;
export const SessionUserGiftCardsFieldsFragmentDoc = gql`
    fragment sessionUserGiftCardsFields on GiftCard {
  cardNumber
  balance
}
    `;
export const TerminalFieldsFragmentDoc = gql`
    fragment terminalFields on Terminal {
  storeId
  termId
  status
}
    `;
export const StorePickupFieldsFragmentDoc = gql`
    fragment storePickupFields on Store {
  storeId
  inStorePickup
  driveThruPickup
  parkingLotPickup
  terminals {
    ...terminalFields
  }
}
    ${TerminalFieldsFragmentDoc}`;
export const OnlineProductGroupDocument = gql`
    query OnlineProductGroup($id: ID!) {
  onlineProductGroup(id: $id) {
    id
    name
    children {
      id
      name
      image
      isVisible
    }
    products {
      ...productFields
      icon
      priority
    }
  }
}
    ${ProductFieldsFragmentDoc}`;

/**
 * __useOnlineProductGroupQuery__
 *
 * To run a query within a React component, call `useOnlineProductGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnlineProductGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnlineProductGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnlineProductGroupQuery(baseOptions: Apollo.QueryHookOptions<OnlineProductGroupQuery, OnlineProductGroupQueryVariables> & ({ variables: OnlineProductGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnlineProductGroupQuery, OnlineProductGroupQueryVariables>(OnlineProductGroupDocument, options);
      }
export function useOnlineProductGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnlineProductGroupQuery, OnlineProductGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnlineProductGroupQuery, OnlineProductGroupQueryVariables>(OnlineProductGroupDocument, options);
        }
// @ts-ignore
export function useOnlineProductGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnlineProductGroupQuery, OnlineProductGroupQueryVariables>): Apollo.UseSuspenseQueryResult<OnlineProductGroupQuery, OnlineProductGroupQueryVariables>;
export function useOnlineProductGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OnlineProductGroupQuery, OnlineProductGroupQueryVariables>): Apollo.UseSuspenseQueryResult<OnlineProductGroupQuery | undefined, OnlineProductGroupQueryVariables>;
export function useOnlineProductGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OnlineProductGroupQuery, OnlineProductGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnlineProductGroupQuery, OnlineProductGroupQueryVariables>(OnlineProductGroupDocument, options);
        }
export type OnlineProductGroupQueryHookResult = ReturnType<typeof useOnlineProductGroupQuery>;
export type OnlineProductGroupLazyQueryHookResult = ReturnType<typeof useOnlineProductGroupLazyQuery>;
export type OnlineProductGroupSuspenseQueryHookResult = ReturnType<typeof useOnlineProductGroupSuspenseQuery>;
export type OnlineProductGroupQueryResult = Apollo.QueryResult<OnlineProductGroupQuery, OnlineProductGroupQueryVariables>;
export const OnlineProductGroupsDocument = gql`
    query OnlineProductGroups($parentId: Int) {
  onlineProductGroups(parentId: $parentId) {
    id
    name
    image
    isVisible
  }
}
    `;

/**
 * __useOnlineProductGroupsQuery__
 *
 * To run a query within a React component, call `useOnlineProductGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnlineProductGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnlineProductGroupsQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useOnlineProductGroupsQuery(baseOptions?: Apollo.QueryHookOptions<OnlineProductGroupsQuery, OnlineProductGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnlineProductGroupsQuery, OnlineProductGroupsQueryVariables>(OnlineProductGroupsDocument, options);
      }
export function useOnlineProductGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnlineProductGroupsQuery, OnlineProductGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnlineProductGroupsQuery, OnlineProductGroupsQueryVariables>(OnlineProductGroupsDocument, options);
        }
// @ts-ignore
export function useOnlineProductGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OnlineProductGroupsQuery, OnlineProductGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<OnlineProductGroupsQuery, OnlineProductGroupsQueryVariables>;
export function useOnlineProductGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OnlineProductGroupsQuery, OnlineProductGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<OnlineProductGroupsQuery | undefined, OnlineProductGroupsQueryVariables>;
export function useOnlineProductGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OnlineProductGroupsQuery, OnlineProductGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnlineProductGroupsQuery, OnlineProductGroupsQueryVariables>(OnlineProductGroupsDocument, options);
        }
export type OnlineProductGroupsQueryHookResult = ReturnType<typeof useOnlineProductGroupsQuery>;
export type OnlineProductGroupsLazyQueryHookResult = ReturnType<typeof useOnlineProductGroupsLazyQuery>;
export type OnlineProductGroupsSuspenseQueryHookResult = ReturnType<typeof useOnlineProductGroupsSuspenseQuery>;
export type OnlineProductGroupsQueryResult = Apollo.QueryResult<OnlineProductGroupsQuery, OnlineProductGroupsQueryVariables>;
export const WebOnlineProductGroupDocument = gql`
    query WebOnlineProductGroup($id: ID!) {
  webOnlineProductGroup(id: $id) {
    id
    name
    children {
      id
      name
      image
      isVisible
    }
    products {
      ...productFields
      icon
      priority
    }
  }
}
    ${ProductFieldsFragmentDoc}`;

/**
 * __useWebOnlineProductGroupQuery__
 *
 * To run a query within a React component, call `useWebOnlineProductGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebOnlineProductGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebOnlineProductGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWebOnlineProductGroupQuery(baseOptions: Apollo.QueryHookOptions<WebOnlineProductGroupQuery, WebOnlineProductGroupQueryVariables> & ({ variables: WebOnlineProductGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebOnlineProductGroupQuery, WebOnlineProductGroupQueryVariables>(WebOnlineProductGroupDocument, options);
      }
export function useWebOnlineProductGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebOnlineProductGroupQuery, WebOnlineProductGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebOnlineProductGroupQuery, WebOnlineProductGroupQueryVariables>(WebOnlineProductGroupDocument, options);
        }
// @ts-ignore
export function useWebOnlineProductGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WebOnlineProductGroupQuery, WebOnlineProductGroupQueryVariables>): Apollo.UseSuspenseQueryResult<WebOnlineProductGroupQuery, WebOnlineProductGroupQueryVariables>;
export function useWebOnlineProductGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebOnlineProductGroupQuery, WebOnlineProductGroupQueryVariables>): Apollo.UseSuspenseQueryResult<WebOnlineProductGroupQuery | undefined, WebOnlineProductGroupQueryVariables>;
export function useWebOnlineProductGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebOnlineProductGroupQuery, WebOnlineProductGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebOnlineProductGroupQuery, WebOnlineProductGroupQueryVariables>(WebOnlineProductGroupDocument, options);
        }
export type WebOnlineProductGroupQueryHookResult = ReturnType<typeof useWebOnlineProductGroupQuery>;
export type WebOnlineProductGroupLazyQueryHookResult = ReturnType<typeof useWebOnlineProductGroupLazyQuery>;
export type WebOnlineProductGroupSuspenseQueryHookResult = ReturnType<typeof useWebOnlineProductGroupSuspenseQuery>;
export type WebOnlineProductGroupQueryResult = Apollo.QueryResult<WebOnlineProductGroupQuery, WebOnlineProductGroupQueryVariables>;
export const WebOnlineProductGroupsDocument = gql`
    query WebOnlineProductGroups($parentId: Int) {
  webOnlineProductGroups(parentId: $parentId) {
    id
    name
    image
    isVisible
  }
}
    `;

/**
 * __useWebOnlineProductGroupsQuery__
 *
 * To run a query within a React component, call `useWebOnlineProductGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebOnlineProductGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebOnlineProductGroupsQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *   },
 * });
 */
export function useWebOnlineProductGroupsQuery(baseOptions?: Apollo.QueryHookOptions<WebOnlineProductGroupsQuery, WebOnlineProductGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebOnlineProductGroupsQuery, WebOnlineProductGroupsQueryVariables>(WebOnlineProductGroupsDocument, options);
      }
export function useWebOnlineProductGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebOnlineProductGroupsQuery, WebOnlineProductGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebOnlineProductGroupsQuery, WebOnlineProductGroupsQueryVariables>(WebOnlineProductGroupsDocument, options);
        }
// @ts-ignore
export function useWebOnlineProductGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WebOnlineProductGroupsQuery, WebOnlineProductGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<WebOnlineProductGroupsQuery, WebOnlineProductGroupsQueryVariables>;
export function useWebOnlineProductGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebOnlineProductGroupsQuery, WebOnlineProductGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<WebOnlineProductGroupsQuery | undefined, WebOnlineProductGroupsQueryVariables>;
export function useWebOnlineProductGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebOnlineProductGroupsQuery, WebOnlineProductGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebOnlineProductGroupsQuery, WebOnlineProductGroupsQueryVariables>(WebOnlineProductGroupsDocument, options);
        }
export type WebOnlineProductGroupsQueryHookResult = ReturnType<typeof useWebOnlineProductGroupsQuery>;
export type WebOnlineProductGroupsLazyQueryHookResult = ReturnType<typeof useWebOnlineProductGroupsLazyQuery>;
export type WebOnlineProductGroupsSuspenseQueryHookResult = ReturnType<typeof useWebOnlineProductGroupsSuspenseQuery>;
export type WebOnlineProductGroupsQueryResult = Apollo.QueryResult<WebOnlineProductGroupsQuery, WebOnlineProductGroupsQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "OrderPayment": [
      "OrderCreditCardPayment",
      "OrderGiftCardPayment"
    ],
    "PercPayment": [
      "PercCreditCardPayment",
      "PercGiftCardPayment"
    ]
  }
};
      export default result;
    